import { of } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, map, catchError, concatMap } from 'rxjs/operators';
//不要encode
import { ajax } from 'rxjs/ajax';

import urls from '@/api/urls';
import * as uiActions from '../ui';
import queryString from 'query-string';
import * as actions from './linkSummary';
import { ajaxBaseConfig, actionApi } from '../../utils';
import { apiBaseConfig } from '@/redux/utils';

export const getLinkSummaryListEpic = actions$ => actions$.pipe(
    ofType(actions.getLinkSummaryList.REQUEST.toString()),
    mergeMap(action => {
        actionApi()
        const { page = 0, size = 20, linkCode = '', systemName = '', startDate = '', endDate = '' } = action.payload;
        let params = `?page=${page}&size=${size}`;
        if (linkCode) params += `&linkCode=${linkCode}`;
        if (systemName) params += `&systemName=${systemName}`;
        if (startDate) params += `&startDate=${startDate}`;
        if (endDate) params += `&endDate=${endDate}`;

        return ajax({
            ...ajaxBaseConfig,
            url: `${urls.dataManage.linkDataCheck.summaryList}${params}`,
        }).pipe(
            map(res => actions.getLinkSummaryList.SUCCESS(res.response)),
            catchError(error => of(actions.getLinkSummaryList.FAIL(error.xhr.response), uiActions.notification(error.xhr.response)))
        )
    }
    )
);

export const handleLinkSummaryRemarkEpic = actions$ => actions$.pipe(
    ofType(actions.handleLinkSummaryRemark.REQUEST.toString()),
    mergeMap(action => {
        actionApi()
        const { id, remark, callback } = action.payload;

        return ajax({
            ...ajaxBaseConfig,
            url: `${urls.dataManage.linkDataCheck.summaryUpdate}`,
            body: { id, remark },
            method: 'PUT'
        }).pipe(
            map(res => {
                callback && callback(res.response);
                return actions.handleLinkSummaryRemark.SUCCESS(res.response)
            }),
            catchError(error => of(actions.handleLinkSummaryRemark.FAIL(error.xhr.response), uiActions.notification(error.xhr.response)))
        )
    }
    )
);
